var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, ButtonMode, ButtonSize, ButtonVariant } from '../Components/Button';
import { ButtonGroup } from '../Components/ButtonGroup';
import { InfoIcon, UserIcon } from '../Components/Icons';
import { primary } from '../Styles/Colours';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { CancelledRequest, useHttpConfig } from '../Shared/HttpRequestExecutor';
import { getPatientMedicationConsumerInformationById, getPatientMedicationProductInformationById } from '../Async/MedicationsSummaryAsync';
import { getConfig } from '../Config/ApplicationConfig';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledPrompt } from '../Components/Prompts/StyledPrompt';
import { divider } from '../Styles/Colours';
var DisplayDocumentPrefix;
(function (DisplayDocumentPrefix) {
    DisplayDocumentPrefix["ProductInformation"] = "ProductInformation";
    DisplayDocumentPrefix["ConsumerSheet"] = "ConsumerSheet";
})(DisplayDocumentPrefix || (DisplayDocumentPrefix = {}));
var DocumentButtonStatus;
(function (DocumentButtonStatus) {
    DocumentButtonStatus[DocumentButtonStatus["Default"] = 0] = "Default";
    DocumentButtonStatus[DocumentButtonStatus["Loading"] = 1] = "Loading";
    DocumentButtonStatus[DocumentButtonStatus["Loaded"] = 2] = "Loaded";
})(DocumentButtonStatus || (DocumentButtonStatus = {}));
var createClinicalSupportDocumentUrl = function (documentInfo) {
    return getConfig().apiEndpoints.medicationsManagement + "api/v1/clinical-documents/" + documentInfo.documentType + "/" + documentInfo.documentCode;
};
var SupportiveDocumentButton = React.forwardRef(function (props, ref) {
    var _a = __read(useState(DocumentButtonStatus.Default), 2), documentButtonStatus = _a[0], setDocumentButtonStatus = _a[1];
    var _b = __read(useState(false), 2), showSupportiveDocumentPrompt = _b[0], setShowSupportiveDocumentPrompt = _b[1];
    var _c = __read(useState(''), 2), promptMessage = _c[0], setPromptMessage = _c[1];
    var documentKey = "medications-" + props.documentPrefix + props.patientMedicationId;
    var httpConfig = useHttpConfig();
    var fetchSupportiveDocumentDetail = props.documentPrefix === DisplayDocumentPrefix.ProductInformation
        ? getPatientMedicationProductInformationById
        : getPatientMedicationConsumerInformationById;
    function onClick() {
        var value = sessionStorage.getItem(documentKey);
        if (value !== null && value !== '') {
            var supportiveDocumentDetail = JSON.parse(value);
            openDocumentInNewTab(supportiveDocumentDetail);
        }
        else {
            getSupportiveDocumentDetail();
        }
    }
    function openDocumentInNewTab(documentInfo) {
        var supportDocumentUrl = createClinicalSupportDocumentUrl(documentInfo);
        window.open(supportDocumentUrl);
    }
    function getSupportiveDocumentDetail() {
        return __awaiter(this, void 0, void 0, function () {
            var supportiveDocumentDetail, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setDocumentButtonStatus(DocumentButtonStatus.Loading);
                        return [4 /*yield*/, fetchSupportiveDocumentDetail(httpConfig, props.patientMedicationId)];
                    case 1:
                        supportiveDocumentDetail = _a.sent();
                        if (supportiveDocumentDetail instanceof CancelledRequest)
                            return [2 /*return*/];
                        if (supportiveDocumentDetail !== null && supportiveDocumentDetail.documentType !== '') {
                            sessionStorage.setItem(documentKey, JSON.stringify(supportiveDocumentDetail));
                            openDocumentInNewTab(supportiveDocumentDetail);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        setShowSupportiveDocumentPrompt(true);
                        if (err_1 instanceof Response && err_1.status === 404) {
                            setPromptMessage(props.buttonText + ' is not available for this medication.');
                        }
                        else {
                            setPromptMessage('An error occured while attempting to fetch this document.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        setDocumentButtonStatus(DocumentButtonStatus.Loaded);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var buttonProps = {
        icon: props.startIcon,
        content: props.buttonText,
        disabled: false
    };
    if (documentButtonStatus === DocumentButtonStatus.Loading) {
        buttonProps.icon = null;
        buttonProps.content = React.createElement(LoadingPlaceholder, { size: 16 });
        buttonProps.disabled = true;
    }
    return (React.createElement("div", null,
        React.createElement(Button, { ref: ref, startIcon: buttonProps.icon, width: props.width, size: props.size, testId: props.testId, mode: ButtonMode.border, variant: ButtonVariant.light, onClick: onClick, disabled: buttonProps.disabled, borderColour: divider }, buttonProps.content),
        React.createElement(SupportiveDocumentPrompt, { open: showSupportiveDocumentPrompt, title: props.buttonText + ' not found', promptMessage: promptMessage, onOK: function () {
                setShowSupportiveDocumentPrompt(false);
            } })));
});
export function EditSupportiveMedicationDocumentation(props) {
    return (React.createElement(ButtonGroup, null,
        React.createElement(SupportiveDocumentButton, { startIcon: React.createElement(InfoIcon, { noPadding: true, size: '20', color: primary }), width: 183, size: ButtonSize.small, patientMedicationId: props.patientMedicationId, documentPrefix: DisplayDocumentPrefix.ProductInformation, buttonText: 'Product information', testId: 'product-information' }),
        props.isTradeProductPack && (React.createElement(SupportiveDocumentButton, { startIcon: React.createElement(UserIcon, { noPadding: true, size: '20', color: primary }), width: 158, size: ButtonSize.small, patientMedicationId: props.patientMedicationId, documentPrefix: DisplayDocumentPrefix.ConsumerSheet, buttonText: 'Consumer sheet', testId: 'consumer-sheet' }))));
}
export var SupportiveDocumentPrompt = function (props) {
    return (React.createElement(StyledPrompt, { open: props.open, title: props.title, onCancel: props.onOK, actions: [
            React.createElement(StyledDialogButton, { title: 'Ok', key: 'ok', onClick: props.onOK, testId: 'ok', width: 100 }, "Ok")
        ] }, props.promptMessage));
};
